import React from "react";
import PropTypes from "prop-types";
import SectionNavigationSearch from "./SectionNavigationSearch";

function SectionNavigation({ title, items, activeKey, searchUrl, searchPlaceholder }) {
  return (
    <nav className="section-navigation" aria-label={title}>
      <div className="section-navigation__title">{title}</div>
      {searchUrl && <SectionNavigationSearch url={searchUrl} placeholder={searchPlaceholder} sectionTitle={title} />}
      <ul className="section-navigation__items">
        {items.map(({ key, label, href, count, icon: Icon }) => {
          const current = key === activeKey;
          return (
            <li key={key}>
              <a
                href={href}
                className={"section-navigation__item" + (current ? " is-current" : "")}
                aria-current={current ? "page" : undefined}
              >
                {Icon && <Icon className="section-navigation__item-icon" width={18} height={18} aria-hidden="true" />}
                <span className="section-navigation__item-label">{label}</span>
                {count > 0 && <span className="section-navigation__item-count"><span className="sr-only">, </span>{count}</span>}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

SectionNavigation.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      count: PropTypes.number,
      icon: PropTypes.elementType,
    })
  ).isRequired,
  activeKey: PropTypes.string,
  searchUrl: PropTypes.string,
  searchPlaceholder: PropTypes.string,
};

export default SectionNavigation;
